/*
* @Author: 王春岩 <Bolt>
* @Date:   2017-02-16 10:30:07
* @Last Modified by:   Bolt
* @Last Modified time: 2017-03-10 15:31:08
*/

'use strict';

import axios from 'axios';

function $getShareCarList(data) {
    return axios({
        url: '/json/car/getShareCarList.json',
        method: 'get',
        params: data
    });
}

function getShareCarList(__p, page, pageSize) {
    return $getShareCarList({
        __p,
        page,
        pageSize
    }).then(response => response.data.data);
}

function $buy(data) {
    return axios({
        url: '/json/car/buy.json',
        method: 'get',
        params: data
    });
}

function buy(data) {
    return $buy(data).then(response => response.data);
}

export {
    getShareCarList,
    buy
};



// WEBPACK FOOTER //
// ./src/api/json/car.js